import { FunctionComponent } from 'preact';
import phoneIconSVG from 'icons/telephone.svg';
import { Stack } from 'components/Stack';
import { ReactSVG } from 'react-svg';

const ICON_SIZE = 24;

interface DropOffNumberProps {
  phoneNumber?: string;
}

const DropOffNumber: FunctionComponent<DropOffNumberProps> = ({
  phoneNumber,
}) => {
  return (
    <Stack isFullWidth gap={8} align="center">
      <ReactSVG
        src={phoneIconSVG}
        width={ICON_SIZE}
        height={ICON_SIZE}
        aria-hidden
      />
      <div>{phoneNumber}</div>
    </Stack>
  );
};

export { DropOffNumber };
